import { useMemo } from 'react'

import { useImpacts } from './use-impacts.hook'
import { IFormSelectedImpacts } from 'src/types'
import { IAccountSelectedIcon } from 'src/components/associations-with-actions'

const useImpactsSelectionWithActions = (
  selectedImpacts: IFormSelectedImpacts[],
  setSelectedImpacts: (impactWithActions: IFormSelectedImpacts[]) => void,
) => {
  const { data: impacts } = useImpacts()

  const selectedImpactsIcons = useMemo(() => {
    if (!impacts?.data.length || !selectedImpacts.length) return null
    return selectedImpacts.reduce<IAccountSelectedIcon[]>((prev, impact) => {
      const item = impacts.data.find((item) => item.id === impact.id)

      if (!item) return prev

      return [
        ...prev,
        {
          subText: '#' + item.code,
          id: item.id,
          icon: item.image_medium || item.image,
          text: item.name,
          aiGenerated: item.ai_generated,
        },
      ]
    }, [])
  }, [selectedImpacts, impacts])

  const handleSelectedImpact = (selectedImpact: IFormSelectedImpacts) => {
    !!selectedImpacts.find((impact) => impact.id === selectedImpact.id)
      ? setSelectedImpacts([...selectedImpacts.filter((impact) => impact.id !== selectedImpact.id)])
      : setSelectedImpacts([...selectedImpacts, selectedImpact])
  }

  return { selectedImpactsIcons, handleSelectedImpact }
}

export { useImpactsSelectionWithActions }
